import { render, staticRenderFns } from "./GatReloadBtn.vue?vue&type=template&id=5974f4a0&scoped=true"
import script from "./GatReloadBtn.vue?vue&type=script&lang=js"
export * from "./GatReloadBtn.vue?vue&type=script&lang=js"
import style0 from "./GatReloadBtn.vue?vue&type=style&index=0&id=5974f4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974f4a0",
  null
  
)

export default component.exports